import * as t from 'io-ts';

export const authMethodSchema = t.keyof({
  native: null,
  oauth: null
}, 'authMethodSchema');
export const authMethodsSchema = t.array(authMethodSchema, 'authMethodsSchema');
